var ORIGIN = "https://ugrzejmnie.pl";
var OG_IMAGE = ORIGIN + "/static/landing/assets/hero-winter-og.jpg";
var OG_LOCALES = { pl: "pl_PL", en: "en_US", de: "de_DE", uk: "uk_UA" };
var HREFLANG_PATHS = ["/", "/dla-dostawcow", "/dla-serwisantow"];

function pagePath() {
  var path = window.location.pathname || "/";
  if (path === "/index.html") path = "/";
  if (path.length > 1 && path.charAt(path.length - 1) === "/") {
    path = path.slice(0, -1);
  }
  return path || "/";
}

function langUrl(path, lang) {
  var url = ORIGIN + path;
  if (lang && lang !== "pl") url += "?lang=" + lang;
  return url;
}

function upsertLink(rel, hreflang, href) {
  var selector = 'link[rel="' + rel + '"]';
  if (hreflang) selector += '[hreflang="' + hreflang + '"]';
  var el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertMeta(attr, key, value) {
  if (!value) return;
  var el = document.head.querySelector("meta[" + attr + '="' + key + '"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function organizationGraph() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": ORIGIN + "/#org",
        name: "UgrzejMnie",
        legalName: "HelpMeNow Prosta Spółka Akcyjna",
        url: ORIGIN + "/",
        logo: ORIGIN + "/static/landing/assets/logo_color.png",
        email: "kontakt@ugrzejmnie.pl",
        telephone: "+48690355556",
        address: {
          "@type": "PostalAddress",
          streetAddress: "ul. Wspólna 2",
          addressLocality: "Mrozy",
          postalCode: "96-330",
          addressCountry: "PL",
        },
        identifier: [
          { "@type": "PropertyValue", name: "KRS", value: "0001127133" },
          { "@type": "PropertyValue", name: "NIP", value: "8381887256" },
          { "@type": "PropertyValue", name: "REGON", value: "529645405" },
        ],
        sameAs: [
          "https://www.facebook.com/ugrzejmnie/",
          "https://play.google.com/store/apps/details?id=pl.ugrzejmnie.customer",
          "https://play.google.com/store/apps/details?id=pl.ugrzejmnie.provider",
        ],
      },
      {
        "@type": "SoftwareApplication",
        "@id": ORIGIN + "/#app",
        name: "UgrzejMnie",
        applicationCategory: "LifestyleApplication",
        operatingSystem: "Android",
        offers: { "@type": "Offer", price: "0", priceCurrency: "PLN" },
        url: "https://play.google.com/store/apps/details?id=pl.ugrzejmnie.customer",
        publisher: { "@id": ORIGIN + "/#org" },
      },
      {
        "@type": "WebSite",
        "@id": ORIGIN + "/#website",
        url: ORIGIN + "/",
        name: "UgrzejMnie",
        inLanguage: ["pl", "en", "de", "uk"],
        publisher: { "@id": ORIGIN + "/#org" },
      },
    ],
  };
}

export function injectSeo(locale) {
  var path = pagePath();
  var descEl = document.querySelector('meta[name="description"]');
  var description = descEl ? descEl.getAttribute("content") : "";
  var lang = locale || document.documentElement.lang || "pl";

  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", document.title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", OG_IMAGE);
  upsertMeta("property", "og:site_name", "UgrzejMnie");
  upsertMeta("property", "og:locale", OG_LOCALES[lang] || "pl_PL");
  upsertMeta("property", "og:image", OG_IMAGE);
  upsertMeta("property", "og:image:width", "1200");
  upsertMeta("property", "og:image:height", "630");

  if (HREFLANG_PATHS.indexOf(path) !== -1) {
    ["pl", "en", "de", "uk"].forEach(function (code) {
      upsertLink("alternate", code, langUrl(path, code));
    });
    upsertLink("alternate", "x-default", langUrl(path, "pl"));
  }

  var jsonld = document.getElementById("jsonld-org");
  if (!jsonld) {
    jsonld = document.createElement("script");
    jsonld.type = "application/ld+json";
    jsonld.id = "jsonld-org";
    document.head.appendChild(jsonld);
  }
  jsonld.textContent = JSON.stringify(organizationGraph());
}
